import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { AuthDTO, AuthResponse } from "../auth.model";

export const authActions = createActionGroup({
  source: "auth",
  events: {
    "Request Login": props<AuthDTO>(),
    "Request Login Success": props<AuthResponse>(),
    "Request Login Failed": props<AuthResponse>(),
    "Request Logout": emptyProps(),
  },
});
